module.exports = __WEBPACK_EXTERNAL_MODULE_138__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react-dom/server","commonjs2":"react-dom/server","amd":"react-dom/server","root":"ReactDOMServer"}
// module id = 138
// module chunks = 0